import { render, staticRenderFns } from "./EmailVerif.vue?vue&type=template&id=64fe20ca&scoped=true&"
import script from "./EmailVerif.js?vue&type=script&lang=js&"
export * from "./EmailVerif.js?vue&type=script&lang=js&"
import style0 from "./EmailVerif.vue?vue&type=style&index=0&id=64fe20ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fe20ca",
  null
  
)

export default component.exports